import HeadphonesIcon from '../../assets/icons/headphones-white-outlined.svg';
import { Layout } from '../../components/Layout/Layout';
import { Page } from '../../components/Page/Page';
import { SElementContainer } from '../Sidebar/Sidebar.styles';
import SidebarElement, { defaultArrowIcon } from '../Sidebar/SidebarElement';
import type { SidebarSection } from '../Sidebar/SidebarElement';
import { translate } from '../../utils/translate';

export const Support = () => {
  const supportItems: SidebarSection[] = [
    {
      nameTx: 'profile_support_internal_support',
      icon: HeadphonesIcon,
      rightIcon: defaultArrowIcon,
      to: '/internal-support',
    },
    {
      nameTx: 'profile_support_general_support',
      icon: HeadphonesIcon,
      rightIcon: defaultArrowIcon,
      to: translate('technicalSupportUrl'),
      target: '_blank',
    },
  ];

  return (
    <Layout isMessageLayout message="support" to="/sidebar" showBottomTabs>
      <Page>
        <SElementContainer role="elementsContainer">
          {supportItems.map(item => (
            <SidebarElement key={item.name} {...item} />
          ))}
        </SElementContainer>
      </Page>
    </Layout>
  );
};
